import { render } from "./descriptionTextArea.vue?vue&type=template&id=2c18091b"
import script from "./descriptionTextArea.vue?vue&type=script&lang=js"
export * from "./descriptionTextArea.vue?vue&type=script&lang=js"

import "./descriptionTextArea.vue?vue&type=style&index=0&id=2c18091b&lang=css"

import exportComponent from "/home/runner/work/weektodo/weektodo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__